import fetch from '@/plugin/axios'

// 添加地图
export function getAddMap (query) {
  return fetch({
    url: '/api/common/map-page/add',
    method: 'Post',
    data: query
  })
}

// 地图列表
export function getMapList (query) {
  return fetch({
    url: '/api/common/map-page/list',
    method: 'Post',
    data: query
  })
}

// 地图详情
export function getMapInfo (id) {
  return fetch({
    url: `/api/common/map-page/info/${id}`,
    method: 'Get'
  })
}

// 编辑地图
export function getMapUpdate (id, query) {
  return fetch({
    url: `/api/common/map-page/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 下上架
export function getMapStatus (id, data) {
  return fetch({
    url: `/api/common/map-page/status/${id}`,
    method: 'Get',
    params: data
  })
}
